import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		// we init with resources
		resources: {
			en: {
				translations: {
				},
			},
			fr: {
				translations: {
					//Dashboard
					"Alerts": "Alertes",
					"Profile": "Profil",
					"Upcoming Classes": "Cours à Venir",
					"This is an important Alert": "Ceci est une alerte importante",
					"This is an information Alert": "Ceci est une alerte d'information",
					"This is a success Alert": "Ceci est une alerte de réussite",
					"Member Since": "Membre Depuis",
					"Belt Level": "Niveau de Ceinture",
					"Profile Completion": "Profil Terminé",
					"Account Members": "Membres du Compte",
					"Black Belt": "Ceinture Noire",
					"This Month at a Glance": "Coup d'œil sur ce mois-ci",
					"Classes Taken": "Cours Suivis",
					"Classes Left": "Classes Restantes",
					"All Time Taken": "Temps Pris",
					"Personal Training Session": "Session de Formation Personnelle",
					//classes
					"Kickboxing Class": "Cours de Kickboxing",
					"Yoga Class": "Cours de Yoga",
					"Spin Class": "Cours de Spin",
					"Boxing Class": "Cours de Boxing",
					"Judo Class": "Cours de Judo",
					//Profile
					"Upload Picture": "Charger une Photo",
					"Alert Settings": "Paramètres d'alerte",
					"Member Information": "Informations Membres",
					"First Name": "Prénom",
					"Last Name": "Nom de Famille",
					"Phone Number": "Téléphone",
					"Address": "Adresse",
					"Country": "Pays",
					"City": "Ville",
					"Save Details": "Enregistrer les Détails",
					"Family Information": "Information Familiale",
					"Family Member": "Membre de la Famille",
					"Add": "Ajouter",
					"Remove": "Retirer",
					"Unlink": "Dissocier",
					"Email Address": "Adresse électronique",
					"Select State": "Sélectionnez l'état",
					"Emergency Contact": "Numéro d'Urgence",
					//Sign In
					"SIGN IN": "SE CONNECTER",
					"Password": "Mot de Passe",
					"Remember Me": "Souviens-toi de Moi",
					"Forgot Password": "Mot de passe oublié",
					"Forgot User": "Utilisateur Oublié",
					"Privacy Policy": "Politique de Confidentialité",
					"Not a Member": "Pas un Membre",
					"Sign Up": "S'inscrire",
					"Guest Sign In": "Connexion Invité",
					"SIGN IN TO MEMBER PORTAL": "SE CONNECTER AU PORTAIL DES MEMBRES",
					//Sign Up
					"SIGN UP": "S'INSCRIRE",
					"SIGN UP IN 3 EASY STEPS": "INSCRIVEZ-VOUS EN 3 ÉTAPES FACILES",
					"Date of Birth": "Date de Naissance",
					"Back": "Retour",
					"I want to receive inspiration, marketing promotions and updates via email": "Je souhaite recevoir de l'inspiration, des promotions marketing et des mises à jour par e-mail",
					"User": "Utilisateur",
					"Account": "Compte",
					"Agreements": "Accords",
					"Next": "Suivant",
					"Finish": "Terminer",
					"Back to Sign In": "Retour à la Connexion",
					"User Name": "Nom d'utilisateur",
					"Confirm Password": "Confirmez le mot de passe",
					"I have read and agree to the user terms": "J'ai lu et j'accepte les conditions d'utilisation",
					//Schedule
					"My Schedule": "Mon Planning",
					"Gym Schedule": "Horaire du Gymnase",
					//Invoices
					"Invoices": "Les Factures",
					"Contract": "Contrats",
					//Navigation
					"Store": "Botique",
					"Schedule": "Programme",
					"Dashboard": "Tableau de Bord",
					"Settings": "Réglages",
					"Profile Info": "Informations profil",
					//Store
					"Add to Cart": "Ajouter au Chariot",
					"Unlimited Classes": "Cours Illimités",

				},
			},
			es: {
				translations: {
					//Dashboard
					"Alerts": "Alertas",
					"Profile": "Perfil",
					"Upcoming Classes": "Próximas Clases",
					"This is an important Alert": "Esta es una alerta importante",
					"This is an information Alert": "Esta es una alerta de información",
					"This is a success Alert": "Esta es una alerta de éxito",
					"Member Since": "Miembro Desde",
					"Belt Level": "Nivel de Cinturón",
					"Profile Completion": "Perfil Completado",
					"Account Members": "Miembros Cuenta",
					"Black Belt": "Cinta Negra",
					"This Month at a Glance": "Este mes de un vistazo",
					"Classes Taken": "Clases Tomadas",
					"Classes Left": "Clases Izquierda",
					"All Time Taken": "Tiempo Tomado",
					"Personal Training Session": "Sesión de Entrenamiento Personal",
					"Date": "Fecha",
					//classes
					"Kickboxing Class": "Clase de Kickboxing",
					"Yoga Class": "Clase de Yoga",
					"Spin Class": "Clase de Spin",
					"Judo Class": "Clase de Judo",
					"Boxing Class": "Clase de Boxing",
					//Profile
					"Upload Picture": "Subir Foto",
					"Questionnaires": "Cuestionarios",
					"Alert Settings": "Configuración de Alertas",
					"Member Information": "Informacion de Miembro",
					"Family Information": "Information Familiale",
					"First Name": "Nombre de Pila",
					"Last Name": "Apellido",
					"Phone Number": "Teléfono",
					"Address": "Alocución",
					"Country": "País",
					"City": "Ciudad",
					"Email Address": "Correo Electrónico",
					"Save Details": "Guardar Detalles",
					"Select State": "Seleccione Estado",
					"Emergency Contact": "Contacto de Emergencia",
					//Sign In
					"SIGN IN": "REGISTRARSE",
					"Password": "Contraseña",
					"Remember Me": "Recuérdame",
					"Forgot Password": "Se te olvidó tu contraseña",
					"Forgot User": "Usuario Olvidado",
					"Privacy Policy": "Política de Privacidad",
					"Not a Member": "No es un Miembro",
					"Sign Up": "Regístrate",
					"Guest Sign In": "Invitado Iniciar Sesión",
					"SIGN IN TO MEMBER PORTAL": "INICIAR SESIÓN EN EL PORTAL DE MIEMBROS",
					//Sign Up
					"SIGN UP": "REGÍSTRATE",
					"SIGN UP IN 3 EASY STEPS": "REGÍSTRESE EN 3 FÁCILES PASOS",
					"Date of Birth": "Fecha de Nacimiento",
					"Back": "Espalda",
					"I want to receive inspiration, marketing promotions and updates via email": "Quiero recibir inspiración, promociones de marketing y actualizaciones por correo electrónico",
					"User": "Usuario",
					"Account": "Cuenta",
					"Agreements": "Acuerdos",
					"Next": "Próximo",
					"Finish": "Terminar",
					"Back to Sign In": "Volver a Iniciar Sesión",
					"User Name": "Nombre de Usuario",
					"Confirm Password": "Confirmar Contraseña",
					"I have read and agree to the user terms": "He leído y acepto las condiciones de uso",
					//Schedule
					"My Schedule": "Mi Horario",
					"Gym Schedule": "Horario de Gimnasio",
					//Invoices
					"Invoices": "Facturas",
					"Contracts": "Contratos",
					//Navigation
					"Store": "Tienda",
					"Schedule": "Calendario",
					"Dashboard": "Tablero",
					"Settings": "Ajustes",
					"Profile Info": "Información de Perfil",
					"Admin": "Administrador",
					//Store
					"Add to Cart": "Añadir al Carrito",
					"Unlimited Classes": "Clases Ilimitadas"
				}
			}
		},
		fallbackLng: "en",
		debug: false,

		// have a common namespace used around the full app
		ns: ["translations"],
		defaultNS: "translations",

		keySeparator: false, // we use content as keys

		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
